import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { environment } from '../../shared/config/app-config';
import { Puser, User, UserService } from '../../shared';
import { SWF } from '../../shared/models';

@Component({
  selector: 'app-toolkit',
  templateUrl: './toolkit.component.html',
  styleUrls: ['./toolkit.component.css']
})
export class ToolkitComponent implements OnInit {
  imageURL: string = environment.cloudeImageURL;
  public data: Object;
  resp: any;
  PUser: Puser;
  CurrentUser: User;
  toolkit: any;
  OpenPDF: boolean = false;

  apiurl: any = environment.api_url;
  documenturl: string = environment.documenturl;
  SWF: SWF;
  type = 'toolkit';

  constructor(
    private http: HttpClient,
    private userService: UserService
  ) { }

  ngOnInit() {
    this.userService.currentUser.subscribe(
      (userData) => {
        this.CurrentUser = userData;
      }
    )
    if (this.CurrentUser.item.hostModel == "CLOUD")
      this.imageURL = environment.cloudeImageURL;
    else
      this.imageURL = environment.vmImageURL;
    this.userService.PUser.subscribe(
      (puserData) => {
        this.resp = puserData;
        this.PUser = puserData;
        //////console.log(this.PUser);    
      }
    )

    this.userService.getbulletinboard(this.type).subscribe(
      data => {
        this.toolkit = data;
        //////console.log( this.toolkit);
      }
    );
  }

  downloadFile(file) {
    return this.http
      .get(file, {
        responseType: 'blob'
      })
      .map(res => {
        return {
          filename: 'filename.pdf',
          data: res
        };
      })
      .subscribe(res => {
        //////console.log('start download:',res);
        var url = window.URL.createObjectURL(res.data);
        var a = document.createElement('a');
        document.body.appendChild(a);
        a.setAttribute('style', 'display: none');
        a.href = url;
        a.download = res.filename;
        a.click();
        window.URL.revokeObjectURL(url);
        a.remove(); // remove the element
      }, error => {
        //////console.log('download error:', JSON.stringify(error));
      }, () => {
        //////console.log('Completed file download.')
      });
  }


}
